import Script from "next/script";

const loadAccessibe = (options = {}) =>
  window.acsbJS?.init({
    statementLink: "",
    footerHtml: "",
    hideMobile: true,
    hideTrigger: true,
    disableBgProcess: false,
    language: "en",
    position: "left",
    leadColor: "#146ff8",
    triggerColor: "#146ff8",
    triggerRadius: "50%",
    triggerPositionX: "right",
    triggerPositionY: "bottom",
    triggerIcon: "people",
    triggerSize: "medium",
    triggerOffsetX: 20,
    triggerOffsetY: 20,
    mobile: {
      triggerSize: "small",
      triggerPositionX: "right",
      triggerPositionY: "bottom",
      triggerOffsetX: 10,
      triggerOffsetY: 10,
      triggerRadius: "50%",
    },
    ...options,
  });

const AccessibeJS = ({ options = {} }) => {
  return (
    <Script
      id="accessibe"
      src="https://acsbapp.com/apps/app/dist/js/app.js"
      async={true}
      strategy="afterInteractive"
      onLoad={() => loadAccessibe(options)}
    />
  );
};

export default AccessibeJS;
